<template>
  <WmsSelectionButton
    v-bind="$attrs"
    :selections="estimationInspectCategorySelections"
    :multiSelect="true"
    :value="internalValue"
    @change="onChange"
  />
</template>
<script>
import WmsSelectionButton from '@wmscomponents/WmsSelectionButton.vue'

const estimationInspectCategorySelections = [
  {
    value: '消防設備点検',
    text: '消防設備点検'
  },
  {
    value: '建築設備定期検査',
    text: '建築設備定期検査'
  },
  {
    value: '特定建築物定期調査',
    text: '特定建築物定期調査',
  },
  {
    value: '防火設備定期検査',
    text: '防火設備定期検査',
  },
  {
    value: '連結送水管耐圧性能点検',
    text: '連結送水管耐圧性能点検',
  },
  {
    value: '共用部設備点検',
    text: '共用部設備点検'
  },
  {
    value: 'エレベーター保守点検',
    text: 'エレベーター保守点検'
  },
  {
    value: '増圧ポンプ点検',
    text: '増圧ポンプ点検'
  },
  {
    value: '給排水ポンプ点検',
    text: '給排水ポンプ点検'
  },
  {
    value: '簡易専用水道',
    text: '簡易専用水道'
  }
]

export default {
  inheritAttrs: false,

  components: {
    WmsSelectionButton
  },
  
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    internalValue() {
      const value = this.value.map((v) => {
        return this.estimationInspectCategorySelections.find((selection) => {
          return selection.value === v
        })
      })
      return value
    }
  },

  data() {
    return {
      estimationInspectCategorySelections
    }
  },

  methods: {
    onChange(selectionItems) {
      const value = selectionItems.map((item) => {
        return item.value
      })
      this.$emit('change', value)
    }
  }
}
</script>